//********** Custom JS **********//


/**
 * Custom code for rendering checkbox and other options dynamically crfeating html.
 */
let SANDBOXmode = false;

 // 1. Your array of options
 const pastMedicalOptions = [
    "Gastroparesis",
    "Pancreatitis",
    "Type 1 diabetes or diabetes requiring insulin",
    "Hypoglycemia",
    "Medullary Thyroid Cancer (MTC) or family history of MTC",
    "Bipolar Disorder",
    "Schizophrenia",
    "Family or personal history of Multiple Endocrine Neoplasia (MEN-2) syndrome",
    "Anorexia or Bulimia",
    "Current symptomatic gallstones or active gallbladder disease",
    "Active Substance Abuse Disorder",
    "Hypertension (high blood pressure)",
    "High cholesterol",
    "Type 2 diabetes",
    "Obstructive sleep apnea",
    "Gout",
    "Metabolic syndrome",
    "Heart disease, stroke, or peripheral vascular disease",
    "Heart Failure",
    "Atrial fibrillation or flutter",
    "Tachycardia or fast heart rate",
    "Any ECG abnormality or heart rhythm abnormality",
    "Gallbladder removed",
    "Fatty Liver (MASLD or MASH)",
    "Cirrhosis or end-stage liver disease",
    "Chronic Kidney Disease Stage 3 or greater",
    "Hypothyroidism, Hyperthyroidism, or Thyroid Issues",
    "None of these"
  ];
  

  const pastGlpTakingYesOptions = [
    "Compounded Semaglutide Injections",
    "Compounded Tirzepatide Injections",
    "Branded Semaglutide (Wegovy or Ozempic)",
    "Branded Tirzepatide (Zepbound or Mounjaro)",
    "Oral Semaglutide",
    "Oral Tirzepatide"
  ];

  
  const medicationOptions = [
    "Compounded Semaglutide – Injection",
    "Compounded Tirzepatide – Injection",
    "Compounded Semaglutide – Orally Dissolving Tablet",
    "Compounded Tirzepatide – Orally Dissolving Tablet",
    "Whatever my provider recommends"
  ];
  const howdoingmedicationoptions = [
    "I am NOT losing weight (1-2 pounds/week) and I am NOT having side effects.",
    "I am NOT losing weight (1-2 pounds/week) and I am having side effects.",
    "I am losing weight (1-2 pounds/week) but I AM having side effects.",
    "I am losing weight (1-2 pounds/week) and I am NOT having side effects."
  ];

  const triedinpastoptions = [
    "Exercise",
    "Dieting",
    "Weight-loss Supplements",
    "Intermittent Fasting",
    "None of the above"
  ];

  const weightLossGoals = [
    "Lose 1-20 lbs for good",
    "Lose 21-50 lbs for good",
    "Lose over 50 lbs for good",
    "Maintain my healthy weight",
    "None of the above"
  ];

  const pregnantbreastfeedingoptions = [ "Yes", "No" ];


  function sanitizeForDomId(str) {
    if(str == null || str == undefined || str == "")
    {
      return "null";
    }
    // Remove invalid characters for IDs (keeping only alphanumerics, underscore, and hyphen)
    // Convert spaces and problematic characters to hyphens
    // Ensure it doesn't start with a number or hyphen (by adding prefix if needed)
    
    let sanitized = str
      .replace(/[^a-zA-Z0-9_-]/g, '-')  // Replace invalid chars with hyphens
      .replace(/-+/g, '-')              // Replace multiple hyphens with single hyphen
      .replace(/^[0-9-]/, 'id-$&');     // Add 'id-' prefix if starts with number or hyphen
    
    return sanitized;
  }

  /**
   * Renders a list of checkbox options into the given container.
   *
   * @param {string} containerSelector  – CSS selector of the parent element
   * @param {string[]} options          – array of labels/values
   * @param {number} step               – numeric step to inject into each id (e.g. 7)
   */
  function renderMultiSelect(containerSelector, options, step, chkname) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    // clear out any existing children
    container.innerHTML = '';

    options.forEach((opt, idx) => {
      const id = `step-${step}-check${idx + 1}`;
      var defvalue = localStorage.getItem(id);
      
      // build the .past-medical-box wrapper
      const box = document.createElement('div');
      box.className = 'past-medical-box';
      if(defvalue == "true"){
          box.innerHTML = `
          <div class="form-check">
            <input class="form-check-input"
                   type="checkbox"
                   id="${id}"
                   name="${chkname}"
                   value="${opt}"
                   checked="${defvalue}"
            />
            <label class="form-check-label" for="${id}">
              ${opt}
            </label>
          </div>
        `;
      }else{
          box.innerHTML = `
            <div class="form-check">
              <input class="form-check-input"
                     type="checkbox"
                     id="${id}"
                     name="${chkname}"
                     value="${opt}"
              />
              <label class="form-check-label" for="${id}">
                ${opt}
              </label>
            </div>
          `;  
      }
      
      container.appendChild(box);
    });
  }

  /**
 * Renders a list of radio options (single-select) into the given container.
 *
 * @param {string} containerSelector  – CSS selector of the parent element
 * @param {string[]} options          – array of labels/values
 * @param {number} step               – numeric step to inject into each id (e.g. 7)
 * @param {string} radioName          – name attribute for the radio group
 */
function renderSingleSelect(containerSelector, options, step, radioName) {
    const container = document.querySelector(containerSelector);
    if (!container) return;
  
    // clear out any existing children
    container.innerHTML = '';
  
    options.forEach((opt, idx) => {
      const id = `step-${step}-radio${idx + 1}`;
      // build the .past-medical-box wrapper
      const box = document.createElement('div');
      box.className = 'past-medical-box';
      box.innerHTML = `
        <div class="form-check">
          <input class="form-check-input"
                 type="radio"
                 id="${id}"
                 name="${radioName}"
                 value="${opt}"
          />
          <label class="form-check-label" for="${id}">
            ${opt}
          </label>
        </div>
      `;
      container.appendChild(box);
    });
  }

  // (optional) helper to get selected values:
  function getSelectedMedicalHistory() {
    return Array.from(
      document.querySelectorAll('.pastmedicalhistory input[type="checkbox"]:checked')
    ).map(cb => cb.value);
  } 
  function getSelectedmedicationTaking() {
    return Array.from(
      document.querySelectorAll('.medicationTaking input[type="checkbox"]:checked')
    ).map(cb => cb.value);
  } 

  function getSelectedTriedInPast() {
    return Array.from(
      document.querySelectorAll('.triedinpast input[type="checkbox"]:checked')
    ).map(cb => cb.value);
  } 

  function getSelectedweightlossGoal() {
    return Array.from(
      document.querySelectorAll('.weightLossGoal input[type="radio"]:checked')
    ).map(cb => cb.value);
  } 

  function getSelectedmedicationInterestTodiscussHistory() {
    
    /*return Array.from(
      document.querySelectorAll('.medicationInterestTodiscuss input[type="radio"]:checked')
    ).map(cb => cb.value);*/

    return Array.from(
      document.querySelectorAll('input[type="radio"][name="medicationInterestTodiscuss"]:checked')
    ).map(cb => cb.value);
    
  } 

  function getSelectedhowdoingmedicationoptionHistory() {
    return Array.from(
      document.querySelectorAll('.howdoingmedicationoption input[type="radio"]:checked')
    ).map(cb => cb.value);
  } 
  
  function getSelectedOptionsForRadio(selector) {
    return Array.from(
      document.querySelectorAll(selector + ' input[type="radio"]:checked')
    ).map(cb => cb.value);
  } 


// wire it all up on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    renderMultiSelect('.pastmedicalhistory', pastMedicalOptions, 7, "pastMedicalHistory");
    
    // for no selected
    //renderSingleSelect('.medicationInterestTodiscuss', medicationOptions, "8n1", "medicationList");

    // for yes selected
    renderMultiSelect('.medicationTaking', pastGlpTakingYesOptions, "8y1", "medicationTakingList");

    renderSingleSelect('.howdoingmedicationoption', howdoingmedicationoptions, "8y4", "howdoingmedicationList");

    renderSingleSelect('.pregnantbreastfeedingoption', pregnantbreastfeedingoptions, "9", "pregnantbreastfeedingList");

    renderMultiSelect('.triedinpast', triedinpastoptions, "12", "triedinpastList");

    renderSingleSelect('.weightLossGoal', weightLossGoals, "13", "weightLossGoalList");

  });



$(function () {

    //********** Select **********//
   // --- Remove the default behavior from labels ---
            // This prevents the label's native behavior from interfering with our custom handling
            document.querySelectorAll('.past-medical-box label, .past-medical-box checkbox').forEach(label => {
                label.addEventListener('click', function(e) {
                    e.preventDefault();
                });
            });
  
    document.querySelectorAll('.past-medical-box').forEach(box => {
        box.addEventListener('click', function (e) {

              // Stop event bubbling to prevent multiple handlers from firing
                e.stopPropagation();
          
             // prevent double‐firing when clicking the actual <input>
                if (e.target.tagName === 'INPUT') return;

                const input = box.querySelector('input');
                const { type, name, id, value } = input;

                if (type === 'checkbox') {

                  
                    // checkbox: just toggle this one
                    input.checked = !input.checked;
                    localStorage.setItem(id, input.checked);
                    box.classList.toggle('selected', input.checked);

                     // If "None of above" is selected, deselect all other checkboxes in the group
                      let matchNonOfthese = "None of these";
                      if (value === matchNonOfthese && input.checked) {
                          document.querySelectorAll(`.past-medical-box input[type="checkbox"][name="${name}"]`).forEach(checkbox => {
                              if (checkbox !== input) {
                                  checkbox.checked = false;
                                  checkbox.closest('.past-medical-box').classList.remove('selected');
                                  localStorage.removeItem($(checkbox).attr("id"));
                              }
                          });
                      }else{
                        document.querySelector(`.past-medical-box input[type="checkbox"][value="${matchNonOfthese}"]`).checked = false;
                        document.querySelector(`.past-medical-box input[type="checkbox"][value="${matchNonOfthese}"]`).closest('.past-medical-box').classList.remove('selected');                        
                        localStorage.removeItem($(document.querySelector(`.past-medical-box input[type="checkbox"][value="${matchNonOfthese}"]`)).attr("id"));
                      }
                  
                }
                else if (type === 'radio') {
                    // radio: unselect all in the same group
                    document.querySelectorAll(`input[type="radio"][name="${name}"]`)
                        .forEach(r => {
                        r.checked = false;
                        r.closest('.past-medical-box').classList.remove('selected');
                        });

                    // select the clicked one
                    input.checked = true;
                    
                    // store the selected value under the group name
                    localStorage.setItem(name, value);
                    box.classList.add('selected');
                }
        });
    });
   
    //********** DatePicker **********//
    $('.datepicker').datepicker({
        format: "yyyy-mm-dd",
        orientation: 'bottom',
        todayHighlight: true,
        autoclose: true
    });

    //********** WOW js **********//
    new WOW({ mobile: false }).init();

    localStorage.setItem('savedStep', 0);
});

function GetCurrentStep() {
    const step = parseInt(localStorage.getItem('savedStep'));
    if (step > 1)
    {
        return parseInt(step);
    }
    else
    {
        SetCurrentStep(1)
        return 1;
    }
};

function SetCurrentStep(step) {
    localStorage.setItem('savedStep', parseInt(step));
}

const totalSteps = $(".step-section").length;
// Function to update progress bar
function updateProgressBar() {
    if($(".step-section.active").length == 0){
      // first time:
      $(".step-section.step1").addClass("active");
      $(".step-section.step1").show();
    }
    const currentIndex = $(".step-section").index($(".step-section.active")) + 1;
    const percentage = Math.round((currentIndex / totalSteps) * 100);

    $(".progress-bar").css("width", percentage + "%");
    $(".progress-text").text(percentage + "%");
}

function updateProgressComplete(){
  $(".progress-bar").css("width", "100%");
  $(".progress-text").text("100%");
}


$(function() {
    // Handle text inputs
    $('.step-section').find('input[type="text"], input[type="number"]').on('input', function() {
        let inputValue = $(this).val();
        let inputKey = $(this).attr('id');
        localStorage.setItem(inputKey, inputValue);
    });

    // Handle textareas
    $('.step-section').find('textarea').on('input', function() {
        let textareaValue = $(this).val();
        let textareaKey = $(this).attr('id');
        localStorage.setItem(textareaKey, textareaValue);
    });

    // Handle select lists
    $('.step-section').find('select').on('change', function() {
        let selectValue = $(this).val();
        let selectKey = $(this).attr('id');
        localStorage.setItem(selectKey, selectValue);
    });

    // Handle jQuery UI datepickers
    /*$('.step-section').find('input.datepicker').on('change', function() {
        let dateValue = $(this).val();
        let dateKey = $(this).attr('id');
        localStorage.setItem(dateKey, dateValue);
    });*/

      $('.step-section').find('input.datepicker').on('change', function() {
        let $input = $(this);
        let dateValue = $input.val();
        let dateKey = $input.attr('id');
    
        // Regex to match yyyy-MM-dd
        let dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    
        // Remove any existing error message
        $input.next('.date-error').remove();
    
        if (!dateRegex.test(dateValue)) {
            $input.after('<div class="date-error" style="color:red;">Date must be in yyyy-MM-dd format.</div>');
            $input.val("");
            return;
        }
    
        // Optional: validate real date (e.g., 2024-02-30 is invalid)
        let parts = dateValue.split("-");
        let year = parseInt(parts[0], 10);
        let month = parseInt(parts[1], 10) - 1;
        let day = parseInt(parts[2], 10);
        let dateObj = new Date(year, month, day);
    
        if (
            dateObj.getFullYear() !== year ||
            dateObj.getMonth() !== month ||
            dateObj.getDate() !== day
        ) {
            $input.after('<div class="date-error" style="color:red;">Invalid date. Please check the value.</div>');
            return;
        }
    
        // If valid, store in localStorage
        localStorage.setItem(dateKey, dateValue);
    });


    // Handle custom dropdown
    $('.step-section').find('.select-dropdown-list-item').on('click', function() {
        let selection = $(this).text();
        let selectionKey = $(this).closest('.select-dropdown').find('.select-dropdown-button').attr('id');
        localStorage.setItem(selectionKey, selection);
    });

    // Handle checkboxes
    $('.step-section').find('input[type="checkbox"]').on('change', function() {
        let checkboxValue = $(this).prop('checked');
        let checkboxKey = $(this).attr('id');
        localStorage.setItem(checkboxKey, checkboxValue);
    });



    // Handle radio selection
    $('.step-section').find('input[type="radio"]').on('change', function() {
        let radioId = $(this).attr('id');
        let radioGroup = $(this).attr('name');
        localStorage.setItem(radioGroup, radioId);
    });

    // Load inputs
    $('.step-section').find('input[type="text"], input[type="number"], select, input.datepicker').each(function() {
        let key = $(this).attr('id');
        if (localStorage.getItem(key)) {
            $(this).val(localStorage.getItem(key));
        }
    });

    // Load textareas
    $('.step-section').find('textarea').each(function() {
        let key = $(this).attr('id');
        if (localStorage.getItem(key)) {
            $(this).val(localStorage.getItem(key));
        }
    });

    // Load selects
    $('.step-section').find('.select-dropdown-button').each(function() {
        let key = $(this).attr('id');
        if (localStorage.getItem(key)) {
            $(this).find('span').text(localStorage.getItem(key));
        }
    });

    // Load checkboxes
    $('.step-section').find('input[type="checkbox"]').each(function() {
        let key = $(this).attr('id');
        if (localStorage.getItem(key) === 'true') {
            
            $(this).prop('checked', true);
        }
    });

    // Load radios
    $('.step-section').find('input[type="radio"]').each(function() {
        let radioGroup = $(this).attr('name');
        let radioId = sanitizeForDomId(localStorage.getItem(radioGroup));
        if(radioId && $(`#${radioId}`).length > 0)
        {
            $(`#${radioId}`).prop('checked', true);
        }
        else{
          if($("input[type=radio][name='"+radioGroup+"'][value='"+ localStorage.getItem(radioGroup) +"']").length > 0){
              $("input[type=radio][name='"+radioGroup+"'][value='"+ localStorage.getItem(radioGroup) +"']").prop("checked", true);
              $("input[type=radio][name='"+radioGroup+"'][value='"+ localStorage.getItem(radioGroup) +"']").closest(".past-medical-box").click()
          }
        }
    });

    // Load past medical boxes
    $('.step-section').find('.past-medical-box input[type="checkbox"]').each(function() {
        let key = $(this).attr('id');
        if (localStorage.getItem(key) === 'true') {
            
            $(this).closest('.past-medical-box').addClass("selected");
        }
    });

    // Save first name for step 4, 6, and 15
    $('#step-3-firstName').on('input', function() {
        let firstName = $(this).val();
        $('#step-4-firstName').text(firstName);
        $('#step-6-firstName').text(firstName);
        $('#step-15-firstName').text(firstName);
        $('#step-18-firstName').text(firstName);
    });

    // Save last name for step 18
    $('#step-3-lastName').on('input', function() {
        let lastName = $(this).val();
        $('#step-18-lastName').text(lastName);
    });

    
    $('.phoneInput').on('keypress', function (e) {
        // Allow only digits (char codes 48-57), backspace (8), delete (46), and arrow keys
        const allowedKeys = [8, 9, 37, 38, 39, 40, 46]; // Backspace, Tab, Arrow keys, Delete
        const isDigit = e.which >= 48 && e.which <= 57;
        const isAllowedKey = allowedKeys.includes(e.which);
        
        if (!isDigit && !isAllowedKey) {
            e.preventDefault();
        }
    }).on('paste', function (e) {
        // Prevent default paste behavior first
        e.preventDefault();
        
        // Get the pasted content
        const paste = (e.originalEvent || e).clipboardData.getData('text/plain');
        
        // Extract only digits from the pasted content
        const digitsOnly = paste.replace(/\D/g, '');
        
        // Get current cursor position for intelligent insertion
        const input = this;
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const currentValue = $(input).val();
        
        // Insert only the digits at the cursor position
        if (digitsOnly.length > 0) {
            const newValue = currentValue.substring(0, start) + digitsOnly + currentValue.substring(end);
            $(input).val(newValue);
            
            // Set cursor position after the inserted digits
            const newCursorPos = start + digitsOnly.length;
            input.setSelectionRange(newCursorPos, newCursorPos);
            
            // Trigger input event for any change listeners
            $(input).trigger('input');
        }
        
        // Optional: Show feedback for filtered content
        if (paste !== digitsOnly && digitsOnly.length > 0) {
            console.log(`Filtered non-digit characters. Original: "${paste}", Inserted: "${digitsOnly}"`);
        } else if (digitsOnly.length === 0) {
            console.log('No valid digits found in pasted content');
        }
    }).on('input', function (e) {
        // Additional safeguard: clean any non-digits that might slip through
        const currentValue = $(this).val();
        const cleanValue = currentValue.replace(/\D/g, '');
        
        if (currentValue !== cleanValue) {
            $(this).val(cleanValue);
        }
    });
  
});

$(function () {
    // Load name for step 4, 6, 15, and 18
    $('#step-4-firstName').text(localStorage.getItem('step-3-firstName') ?? "Name");
    $('#step-6-firstName').text(localStorage.getItem('step-3-firstName') ?? "Name");
    $('#step-15-firstName').text(localStorage.getItem('step-3-firstName') ?? "Name");
    $('#step-18-firstName').text(localStorage.getItem('step-3-firstName') ?? "Name");
    $('#step-18-lastName').text(localStorage.getItem('step-3-lastName') ?? "Name");
    
});


//********** Step Process **********//
$(function () {

    let savedStep = GetCurrentStep();

    if(savedStep == "19" || savedStep == 19 || parseInt(savedStep) > 20){
        savedStep == "1"
    }
  
    if (savedStep && savedStep > 0 && savedStep <= totalSteps) {
        $(".step-section").hide();
        $(".step" + savedStep).show().addClass("active");
    }
    else {
        // Show only step1 initially
        $(".step-section").hide();
        $(".step1").show().addClass("active");
    }

    updateProgressBar(); // Initialize

    //Handle next button click
    $(".next-btn").on("click", function () {

        let savedStep = GetCurrentStep();
        let currentStep = $(this).closest(".step-section");
        let nextStep = currentStep.next(".step-section");
      
        // validate for mandaotry fields before proceed. 

        // Email validation.
        if(document.querySelector("#step-3-email").value == "" && savedStep > 3){
          // email mandaotry.
            nextStep = $(".step3.step-section");
            currentStep.removeClass("active").hide();
            nextStep.addClass("active").fadeIn();
            SetCurrentStep(3);
            updateProgressBar();
            $(document.querySelector("#step-3-email")).focus();
            return;
        }else if (savedStep == 3 && document.querySelector("#step-3-email").value.length > 0){
            // validate email
            const emailInput = document.querySelector("#step-3-email").value.trim();
            const basicEmailPattern = /^[^@]+@[^@]+\.[^@]+$/;
        
            if (!basicEmailPattern.test(emailInput)) {
                //alert("Please enter a valid email with '@' and '.'");
                $(document.querySelector("#step-3-email")).focus();
                return; // Stop further processing
            }
        }
        
        

        saveStepData(currentStep.attr("class").replaceAll(" ","-"));
      
        let form = currentStep.find('form');

        if(form.attr("id") == "step-16-upload")
        {
          $("#errorMsgFileUploadGovDoc").html("");
          // mandatory form for gov id
            let dropzoneInstance = Dropzone.forElement("#step-16-upload");
            if (dropzoneInstance.files.length === 0) {        
                $(".dropzone").addClass("is-invalid"); // Add invalid class for styling
                $("#errorMsgFileUploadGovDoc").html("<b class='alert alert-danger'>Please upload a file.</b>");
                return;
            } else {
                $(".dropzone").removeClass("is-invalid"); // Remove invalid class if valid                
            }            
        }

        
        // if MALE then dont ask pregnency question and skip to next / previous
        if(nextStep.hasClass("step9") == true && $("#step-3-gender").val() == "Male"){
            // skip and go to next step
            // Set NO.
            $("#step-9-radio2").prop("checked", true);
            $("#step-9-radio2").next("label").click()
            nextStep.find(".next-btn").click();
            SetCurrentStep(parseInt(savedStep) + 1 + 1);
        }
        if($(".date-error").length > 0){
          return;
        }
      
        if(form.length && !form[0].reportValidity())
        {
            return;
        }

        if (nextStep.length) {
            currentStep.removeClass("active").hide();
            nextStep.addClass("active").fadeIn();
            updateProgressBar();
            SetCurrentStep(parseInt(savedStep) + 1);

          window.scrollTo({
            top: 0,
            behavior: 'smooth' // for smooth scroll effect
          });
        }
    });

    $(".back-btn").on("click", function () {
        let savedStep = GetCurrentStep();
        let currentStep = $(this).closest(".step-section");
        let prevStep = currentStep.prev(".step-section");
        if(this.attributes["gotostep"] != null && document.querySelector(this.attributes["gotostep"].value) != null)
        {
            prevStep = $(this.attributes["gotostep"].value);
        }

        if (prevStep.length) {
            currentStep.removeClass("active").hide();
            prevStep.addClass("active").fadeIn();
            updateProgressBar();
            SetCurrentStep(parseInt(savedStep) - 1);

          window.scrollTo({
            top: 0,
            behavior: 'smooth' // for smooth scroll effect
          });
                
        }
    });

    $("#step-8-inlineRadio2").on("click", function () {
            $(".step8_no.step-section").fadeIn();
            $(".step-section.active").removeClass("active");
            $(".step8_no.step-section").addClass("active");
            $(".step-section.active").find(".next-btn").click();
            $(".step-section.active").find(".back-btn").click();
      
            //$(this).closest(".step-section").fadeOut();
        });



    /*
      document.getElementById('chkbillingsameasshipping').addEventListener('change', function () {
        const billingDiv = document.getElementById('billcontrolselection');
        if (this.checked) {
          billingDiv.style.display = 'none';
        } else {
          billingDiv.style.display = 'block';
        }
      });
    

  // Format card number as 1234 5678 9012 3456
      document.getElementById('cardNumber').addEventListener('input', function () {
        let value = this.value.replace(/\D/g, '').substring(0, 16); // Only digits, max 16
        value = value.replace(/(.{4})/g, '$1 ').trim(); // Add space every 4 digits
        this.value = value;
      });
      
      // Format expiry date as MM/YY
      document.getElementById('cardExpiry').addEventListener('input', function () {
        let value = this.value.replace(/\D/g, '').substring(0, 4); // Only digits, max 4
        if (value.length >= 3) {
          value = value.replace(/(\d{2})(\d{1,2})/, '$1/$2');
        }
        this.value = value;
      });
      
      // Only allow 3 or 4 digit CVV
      document.getElementById('cardCvv').addEventListener('input', function () {
        this.value = this.value.replace(/\D/g, '').substring(0, 4);
      });
  */
  
});

// ** BMI Calculator *//

$(function() {
    // Function to calculate BMI
    function calculateBMI() {
        // Get input values
        let feet = parseFloat($('#step-5-feet').val()) || 0;
        let inches = parseFloat($('#step-5-inches').val()) || 0;
        let weight = parseFloat($('#step-5-lbs').val()) || 0;
        let goalWeight = parseFloat($('#step-5-goalLbs').val()) || 0;

        // Convert height to total inches
        let totalInches = (feet * 12) + inches;

        // Calculate BMI: (weight in lbs * 703) / (height in inches)^2
        let bmi = 0;
        if (totalInches > 0) {
            bmi = 703 * (weight / (totalInches * totalInches));
            bmi = bmi.toFixed(1); // Round to 1 decimal place
        }

        let goalBmi = 0;
        if (goalWeight > 0) {
            goalBmi = 703 * (goalWeight / (totalInches * totalInches));
            goalBmi = goalBmi.toFixed(1); // Round to 1 decimal place
        }

        // Assign BMI to the output element
        $('#step-5-bmi').text(bmi);
        $('#step-5-goal-bmi').text(goalBmi);
        localStorage.setItem('step-5-bmi', bmi);
        localStorage.setItem('step-5-goal-bmi', goalBmi);
    }

    calculateBMI(); // Initial calculation
    // Trigger calculation on input change
    $('#step-5-feet, #step-5-inches, #step-5-lbs, #step-5-goalLbs').on('input', calculateBMI);
});


// Generate a client-side GUID
const clientGuid = crypto.randomUUID();

const hostdomain = "https://appbundle.bariatricpal.com"; // Change this to your host domain

//********** Dropzone **********//
Dropzone.autoDiscover = false;
$(".dropzone").dropzone({
    addRemoveLinks: true,
    paramName: "file",
    url: hostdomain + '/GlpIntake/FileUpload',
    maxFilesize: 5, // in MB
    acceptedFiles: ".jpg,.jpeg,.png,.pdf", // allowed extensions
    params: function () {
        return { guid: clientGuid };
    },
    sending: function (file, xhr, formData) {
      
        formData.append("guid", clientGuid);
        formData.append("uploadedfile", file);
        console.log(file);
        localStorage.setItem('upload_file', file.name);
         // If you need to use this GUID later (e.g., form submit), you can save it to hidden input or localStorage
        localStorage.setItem('upload_guid', clientGuid);
    },
    removedfile: function (file) {
        let name = file.name;
        $.ajax({
            url: hostdomain + '/GlpIntake/RemoveFile',
            type: 'POST',            
            data: { name: name, guid: clientGuid, request: 2 },
            sucess: function (data) {
                console.log('success: ' + data);
            }
        });
        let _ref;
        return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
    }
});

function getFormData() {
    const formData = {};

    // Collect text, number, date inputs
    document.querySelectorAll('input[type="text"], input[type="number"], input.datepicker').forEach(input => {
        formData[input.id] = input.value;
    });

  // Files
    Dropzone.instances.forEach(instance => {
        const elementId = instance.element.id || instance.element.className || "unnamed";
        console.log(`Dropzone element: ${elementId}`);

        let cnt = 0;
        instance.files.forEach(file => {
            console.log(`→ File name: ${file.name}`);          
              formData[elementId + "_" + cnt] = file.name;
              cnt = cnt + 1;
        });
        
    });
  
    // select
    document.querySelectorAll('select').forEach(input => {
        formData[input.id] = input.value;
    });

    // Textareas
    document.querySelectorAll('textarea').forEach(textarea => {
        formData[textarea.id] = textarea.value;
    });

    // Checkboxes
    document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        if (!formData[checkbox.name]) formData[checkbox.name] = [];
        if (checkbox.checked) formData[checkbox.name].push(checkbox.value || checkbox.id);
    });

    // Radios
    document.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
        formData[radio.name] = radio.value;
    });

    // Custom dropdowns
    document.querySelectorAll('.select-dropdown-button').forEach(button => {
        formData[button.id] = button.querySelector('span').innerText.trim();
    });

    // Dynamic checkboxes from your `renderMultiSelect` helpers
    formData["pastmedicalhistory"] = getSelectedMedicalHistory();
    formData["medicationTaking"] = getSelectedmedicationTaking();
    formData["triedinpast"] = getSelectedTriedInPast();
    formData["medicationInterestTodiscuss"] = getSelectedmedicationInterestTodiscussHistory();
  
    formData["howdoingmedicationoption"] = getSelectedhowdoingmedicationoptionHistory();
    formData["pregnantbreastfeedingoption"] = getSelectedOptionsForRadio('.pregnantbreastfeedingoption');
    formData["weightLossGoal"] = getSelectedweightlossGoal();

    formData["currentstep"] = ("STEP:" + $(".step-section.active").data("stepnum")) || $(".step-section.active").attr("class");
  
    const urlParams = new URLSearchParams(window.location.search);
    const bundleId = urlParams.get('bundleid') || "d2f10602-97eb-47de-a81e-04d8b57b5178";  // Personalized GLP-1 Injection
    formData["productBundleId"] = bundleId;

    const prod = getProductByBundle(bundleId);
  
    if (prod) {
      formData["paymentAmount"] = prod.price;
    } else {
      formData["paymentAmount"] = 1;
    }

    if(shippingAddress != null){
      formData["addressLine1"] = shippingAddress.addressLine1;
      formData["addressLine2"] = shippingAddress.addressLine2;
      formData["city"] = shippingAddress.city;
      formData["state"] = shippingAddress.state;
      formData["postalCode"] = shippingAddress.postalCode;
    }
  
    return formData;
}

function submitWithPayment(paykey){

  try {
    let formData = new FormData();

    formData = getFormData();
    formData["StripeSetupId"] = document.getElementById('stripe_setup_id').value;
    formData["clientGuid"] = clientGuid;
    // div ids and need its values
    formData["step-5-goalLbs"] = localStorage.getItem('step-5-goalLbs');
    formData["step-5-bmi"] = localStorage.getItem('step-5-bmi');
    formData["step-5-goal-bmi"] = localStorage.getItem('step-5-goal-bmi');
    formData["paymentDescription"] = "careglp-patient-register at BariatricPal"

    formData["completed"] = "true";
  
    const urlParams = new URLSearchParams(window.location.search);
    const bundleId = urlParams.get('bundleid') || "d2f10602-97eb-47de-a81e-04d8b57b5178";  // Personalized GLP-1 Injection
    formData["productBundleId"] = bundleId;

    const prod = getProductByBundle(bundleId);
  
    if (prod) {
      formData["paymentAmount"] = prod.price;
    } else {
      formData["paymentAmount"] = 1;
    }
  
    
  
  
    console.log(JSON.stringify(formData));
    //let finalsavecall = "https://localhost:7276/Home/Take";
    let finalsavecall = hostdomain + '/GlpIntake/SubmitIntake';
    if(SANDBOXmode == true){
        finalsavecall = "https://appbundle.bariatricpal.com/DemoStripePay/Take";
    }
  
    fetch(finalsavecall, {
        method: 'POST',
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error("Network response was not ok " + response.statusText);
        }
        return response.json();
    })
    .then(data => {

        hideLoader();
        console.log("Form submitted successfully:", data);
        // optionally show success UI feedback
        if(data.success == true){
          updateProgressComplete();
          
          $("#hdnCaseid").val(data.caseId);
          $("#finalmsg").addClass("alert alert-success");
          $("#finalmsg").html("Payment authorization successful. You will auto redirect to BariatricPal.");

          $(".successmsgsection").show();
          $(".successmsgsection").addClass("active");

          $(".paybuttonsection").hide();
          $(".paybuttonsection").removeClass("active");

          updateSuccessPaymentCountdownMessage();
          
          window.scrollTo({
            top: 0,
            behavior: 'smooth' // for smooth scroll effect
          });
          
        }else{
          
          $("#immerrormsg").addClass("alert alert-danger");
          $("#immerrormsg").html("Failed to collect data at the moment. " + data.message);

          window.logCustomError(finalsavecall + ' error' + JSON.stringify(data), { 
                userId: 123, 
                errorMsg: JSON.stringify(data),
                action: 'button_click' 
            });
          
        }
        setTimeout(function(){ $("#finalmsg").html(""); $("#finalmsg").removeClass("alert alert-success").removeClass("alert alert-error"); }, 10000);
    })
    .catch(error => {
        console.error("Error submitting form:", error);
      hideLoader();
        // optionally show error UI feedback
    });

    saveStepData("100");
  
    
  } catch (error) {
    console.error("Error in our save method :", error);
     window.logCustomError('Error in our save method' + JSON.stringify(data), { 
                userId: 555, 
                errorMsg: JSON.stringify(error),
                action: 'submitWithPayment' 
            });
  }
}
$("#submit-data").on("click", function () {

    let formData = new FormData();

    formData = getFormData();
    formData["step-15-stripekey"] = document.getElementById('stripe_setup_id').value;
    formData["clientGuid"] = clientGuid;
    // div ids and need its values
    formData["step-5-goalLbs"] = localStorage.getItem('step-5-goalLbs');
    formData["step-5-bmi"] = localStorage.getItem('step-5-bmi');
    formData["step-5-goal-bmi"] = localStorage.getItem('step-5-goal-bmi');
  
  
    console.log(JSON.stringify(formData));

    // TEST MODE ENABLED 
    /*     $("#hdnCaseid").val("76c1e60c-0e9a-4c9e-824b-d7fb12f53cfd");
          $("#finalmsg").addClass("alert alert-success");
          $("#finalmsg").html("We have successfully collect your data. Please proceed for payment authorization. It will not charge right now.");
          setTimeout(function(){ $("#finalmsg").html(""); $("#finalmsg").removeClass("alert alert-success").removeClass("alert alert-error"); }, 5000);
      return;
  */
    // TEST MODE

    fetch( hostdomain + '/GlpIntake/SaveLocalIntake', {
        method: 'POST',
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error("Network response was not ok " + response.statusText);
          window.logCustomError('SaveLocalIntake error' + response.statusText, { 
                userId: 123, 
                errorMsg:response.statusText,
                action: 'button_click' 
            });
          
        }
        return response.json();
    })
    .then(data => {
        console.log("Form submitted successfully:", data);
        
        setTimeout(function(){ $("#finalmsg").html(""); $("#finalmsg").removeClass("alert alert-success").removeClass("alert alert-error"); hideLoader(); }, 5000);
    })
    .catch(error => {

      window.logCustomError('SaveLocalIntake error' + error, { 
                userId: 123, 
                errorMsg:error,
                action: 'button_click' 
            });
        console.error("Error submitting form:", error);
        // optionally show error UI feedback
      hideLoader();
    });


});


function showLoader() {
    document.getElementById('loader').style.display = 'block';
}

function hideLoader() {
    document.getElementById('loader').style.display = 'none';
}

let seconds = 10;
function updateSuccessPaymentCountdownMessage() {
  if (seconds > 0) {
    $("#finalmsg").html(`Payment authorization successful. You will be redirected to BariatricPal in ${seconds} seconds.`);
    seconds--;
    setTimeout(updateSuccessPaymentCountdownMessage, 1000);
  } else {
    
    if($(".step18").attr("data-redirecturl") != "") {
      window.location.href = $(".step18").attr("data-redirecturl");  
    }
    else {
      window.location.href = "https://store.bariatricpal.com/pages/lose-weight-with-glp-1-medications?pay=success";
    }
    
  }
}

function displayErrorMessage(msg) {
  $("#immerrormsg").html(
      'Payment authorization failed. Please try again. ' + msg
    );
  $("#immerrormsg").addClass("alert alert-danger");

  setTimeout(function(){  $("#immerrormsg").removeClass("alert alert-danger"); $("#immerrormsg").html(""); }, 20000);

  saveStepData("paymentfailure");
}

function saveStepData(nextstep){
  try {

    var formData = getFormData();
    formData["clientGuid"] = clientGuid;
    // div ids and need its values
    formData["step-5-goalLbs"] = localStorage.getItem('step-5-goalLbs');
    formData["step-5-bmi"] = localStorage.getItem('step-5-bmi');
    formData["step-5-goal-bmi"] = localStorage.getItem('step-5-goal-bmi');

    let options1 = {
      method: 'post',
      headers: {
        'Cache-Control': 'no-cache',
        Accept: '*/*',
        'User-Agent': 'Fetch Client',
        'Accept-Encoding': 'gzip, deflate',
        Connection: 'keep-alive'
      },
      body: JSON.stringify(formData)
    };
  
  fetch(hostdomain + `/GlpIntake/UpdateIntakeDetails?guid=${clientGuid}&step=${nextstep}`, options1)
    .then(response => response.json())
    .then(response => console.log(response))
    .catch(err => console.error(err));

    
  } catch (error) {
    console.error(error);
  }
  
}


let shippingAddress = null;

function initPayStep() {
  let amount = 298; // assign based on product bundle selected
  const colorPrimary = 'rgb(107, 74, 35)';
  let clientSecret = '';
  let stripe, elements;
  let stripeSetupId = '';
  let paymentElement = null;
  let addressElement = null;

  document.querySelector('#payment-method').addEventListener('shown.bs.modal', async () => {
    hideLoader();
    $("#chkconfirmpaymentbefore").prop("checked", false);

    // 🧹 Unmount old Stripe elements if any
    if (paymentElement) {
      paymentElement.unmount();
      paymentElement = null;
    }
    if (addressElement) {
      addressElement.unmount();
      addressElement = null;
    }

    // 🧹 Remove old form to prevent duplicate mount
    const existingForm = document.getElementById('payment-form');
    if (existingForm) existingForm.remove();

    // 🔐 Initialize Stripe if not already done
    if (!stripe) {
      stripe = Stripe(SANDBOXmode
        ? 'pk_test_51RLPV7RgB9LBtRn354FffElKJTST3T3VzjSZNo3Sk2ZTyZXz0NcJSOVv5N9ymepM6dhwq1GB7seNYUrc5OnsBGgf00uRdHhYBo'
        : 'pk_live_51HqSIiKAXrtjbq2dtXcGLkFqhqPquraau6jRB8nDCrDVIGj7me2ZEAiQxZNwuG9A7Y1Gzn6vg8xslQuCpoTByMKd00cmPemstt');
    }

    clientSecret = await initiateSetupIntent();
    if (!clientSecret) {
      document.querySelector('#closepopup').click();
      displayErrorMessage("Unable to generate payment request");
      return;
    }

    elements = stripe.elements({
      clientSecret,
      appearance: {
        theme: 'stripe',
        variables: {
          colorPrimary,
          fontFamily: '"DM Sans", sans-serif',
          fontSizeBase: '16px',
        }
      },
      fonts: [{ cssSrc: 'https://fonts.googleapis.com/css?family=DM+Sans' }]
    });

    injectStripeUI();

    saveStepData("PAYPOPUP");
  });

  function injectStripeUI() {
    const modal = document.querySelector('#payment-method .modal-body #mainForm');

    const stripeContainer = document.createElement('div');
    stripeContainer.innerHTML = `
      <form id="payment-form" onsubmit="return false;">
        <div id="address-element" class="mb-2"></div>
        <div id="address-errors" class="text-danger mb-2" role="alert"></div>
        <div id="card-element" class="mb-2"></div>
        <div id="card-errors" class="text-danger mb-2" role="alert"></div>
        <div id="payment-success" class="alert alert-success d-none"></div>
      </form>
    `;
    modal.appendChild(stripeContainer);

    addressElement = elements.create('address', {
      mode: 'shipping',
      allowedCountries: ['US'],
      defaultValues: {
        name: `${document.getElementById('step-3-firstName').value} ${document.getElementById('step-3-lastName').value}`,
      }
    });
    addressElement.mount('#address-element');
    addressElement.on('change', event => {
      const addr = event.value?.address;
      document.getElementById('address-errors').textContent = event.error?.message || '';
      if (event.complete && addr) {
        shippingAddress = {
          addressLine1: addr.line1 || '',
          addressLine2: addr.line2 || '',
          city: addr.city || '',
          state: addr.state || '',
          postalCode: addr.postal_code || '',
          country: addr.country
        };
        console.log(shippingAddress);
      }
    });

    paymentElement = elements.create('payment');
    paymentElement.mount('#card-element');
    paymentElement.on('change', event => {
      document.getElementById('card-errors').textContent = event.error?.message || '';
    });

    const btnclosepopup = document.querySelector('#closepopup');
    const originalSendButton = document.querySelector('#btnsubmitpayment');
    const clonedSendButton = originalSendButton.cloneNode(true);
    originalSendButton.style.display = 'none';
    originalSendButton.parentNode.insertBefore(clonedSendButton, originalSendButton.nextSibling);

    clonedSendButton.addEventListener('click', async function (event) {
      event.preventDefault();
      this.disabled = true;
      const originalText = this.innerHTML;
      this.innerHTML = `<span class="spinner-border spinner-border-sm me-2"></span> Processing...`;

      try {
        showLoader();

        let email = document.getElementById('step-3-email').value;
        const result = await stripe.confirmSetup({
          elements,
          redirect: 'if_required',
          confirmParams: {
            payment_method_data: { billing_details: { email } }
          }
        });

        if (result.error && result.error.type !== 'validation_error') {
          document.getElementById('card-errors').textContent = result.error.message;
        } else if (result.setupIntent?.status === 'succeeded') {
          stripeSetupId = result.setupIntent.id;
          document.getElementById('stripe_setup_id').value = stripeSetupId;

          const successMsg = document.getElementById('payment-success');
          successMsg.classList.remove('d-none');
          successMsg.textContent = `Payment authorization successful.`;

          submitWithPayment(stripeSetupId);
          btnclosepopup.click();
          originalSendButton.click(); // trigger original form submission
        } else {
          console.error('Payment authorization was not successful: ' + JSON.stringify(result) + JSON.stringify(shippingAddress) + JSON.stringify(getFormData()));
          throw new Error('Payment authorization was not successful');
          displayErrorMessage("Payment authorization was unsuccessful.");
        }
      } catch (err) {
        console.error('Payment error:', err);
        btnclosepopup.click();
        displayErrorMessage(err);
      } finally {
        this.disabled = false;
        this.innerHTML = originalText;
        hideLoader();
      }
    });
  }

  async function initiateSetupIntent() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const bundleId = urlParams.get('bundleid') || "d2f10602-97eb-47de-a81e-04d8b57b5178";
      const prod = getProductByBundle(bundleId);

      if (prod) amount = prod.price;

      if (SANDBOXmode) {
        const response = await fetch("https://appbundle.bariatricpal.com/DemoStripePay/get/3", {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ amount })
        });
        const data = await response.json();
        return data.data;
      }

      const response = await fetch(`${hostdomain}/GlpIntake/initiatePayment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount })
      });
      const data = await response.json();
      return data.paymentSecret;

    } catch (err) {
      console.error('Failed to initiate payment:', err);
      return '';
    }
  }
}

(function () {
     initPayStep();
})();

document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.querySelector('.chkconfirmpaymentbefore');
  const container = document.getElementById('divafteragreepayment');

  // Function to update all buttons inside the container
  function updateButtonsState(enabled) {
    const buttons = container.querySelectorAll('button');
    buttons.forEach(btn => btn.disabled = !enabled);
  }

  // Initial state
  updateButtonsState(checkbox.checked);

  // On checkbox toggle
  checkbox.addEventListener('change', function () {
    updateButtonsState(this.checked);
  });


  if($(".step-section.active").is(":visible") == false){
    $(".step-section.active").show();
  }
  
});





// Simple Error Tracker - Add this to any HTML page
(function() {
    // Configuration
    const ERROR_ENDPOINT = 'https://appbundle.bariatricpal.com/ErrorCatch/LogError';
    
    // Error tracking function
    function logError(errorData) {
        try {
            fetch(ERROR_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    message: errorData.message || 'Unknown error',
                    url: window.location.href,
                    source: errorData.source || '',
                    line: errorData.line || 0,
                    column: errorData.column || 0,
                    stack: errorData.stack || '',
                    userAgent: navigator.userAgent,
                    timestamp: new Date().toISOString(),
                    errorType: errorData.errorType || 'javascript'
                })
            }).catch(function(fetchError) {
                console.error('[ErrorTracker] Failed to send error:', fetchError);
            });
        } catch (e) {
            console.error('[ErrorTracker] Error in logError function:', e);
        }
    }

    // Catch JavaScript errors
    window.addEventListener('error', function(event) {
        logError({
            message: event.message,
            source: event.filename,
            line: event.lineno,
            column: event.colno,
            stack: event.error && event.error.stack ? event.error.stack : '',
            errorType: 'javascript'
        });
    });

    // Catch unhandled promise rejections
    window.addEventListener('unhandledrejection', function(event) {
        logError({
            message: 'Unhandled Promise Rejection: ' + (event.reason || 'Unknown'),
            stack: event.reason && event.reason.stack ? event.reason.stack : '',
            errorType: 'promise'
        });
    });

    // Manual error logging function (optional)
    window.logCustomError = function(message, additionalData) {
        logError({
            message: message,
            stack: additionalData,
            errorType: 'custom',
            ...additionalData
        });
    };

    // Console override to catch console.error calls (optional)
    const originalConsoleError = console.error;
    console.error = function() {
        // Call original console.error
        originalConsoleError.apply(console, arguments);
        
        // Log to our system
        const message = Array.from(arguments).map(arg => 
            typeof arg === 'object' ? JSON.stringify(arg) : String(arg)
        ).join(' ');
        
        logError({
            message: 'Console Error: ' + message,
            stack: document.getElementById('step-3-email').value,
            errorType: 'console'
        });
    };

    console.log('[ErrorTracker] Initialized successfully');
})();

